module.exports = __webpack_public_path__ + "img/p10.a102548f.png";